module.exports = __webpack_public_path__ + "media/images/ghost-icon-8c0dccda1521092245ea0ea2aa893840.ico";